// 导入组件
import Vue from 'vue';
import Router from 'vue-router';

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch((err) => err)
}
// 登录
import login from '@/views/login';
// 首页
import work from '@/views/work/index';
import index from '@/views/index';
/**
 * 用工中心
 */
// 结算商户
import merchantList from '@/views/task/merchantList';
// 任务列表
import taskList from '@/views/task/taskList';
// 任务报名详情
import registrationDtl from '@/views/task/registrationDtl';
// 用工结算单
import employmentStatement from '@/views/task/employmentStatement';
// 结算单详情
import employmentStatementDetail from '@/views/task/employmentStatementDetail';
// 提交结算单
import employmentStatementSubmit from '@/views/task/employmentStatementSubmit';

// 用工结算明细
import employmentStatementDesc from '@/views/task/employmentStatementDesc';
// 自由职业者列表
import professionalList from '@/views/task/professionalList';
// 导出列表
import exportList from '@/views/task/exportList';
// 开票记录-导出记录
import payExportList from '@/views/payCenter/payExportList';
// 报名详情-导出记录
import registrationExportList from '@/views/task/registrationExportList';
// 自由职业者导入合同日志
import contractMigrationLog from '@/views/task/contractMigrationLog';

// 自由职业者导入合同日志详情
import contractMigrationLogDtl from '@/views/task/contractMigrationLogDtl';
// 开票记录-导出记录

/**
 * 合规中心
 */
// 任务信息维护
import complianceCenter from '@/views/ruleCenter/complianceCenter';
/**
 * 管理中心
 */
// 合同管理
import contractManage from '@/views/manageCenter/contractManage';
// 功能配置
// import funConfig from '@/views/manageCenter/funConfig';
/**
 * 财务中心
 */
// 余额管理
import balanceManage from '@/views/payCenter/balanceManage';
// 销售/代理商余额管理
import balance from '@/views/payCenter/balance';
// 充值记录
import rechargeRecord from '@/views/payCenter/rechargeRecord';
// 开票记录
import billingRecordList from '@/views/payCenter/billingRecordList';
// 开票记录
import applybilling from '@/views/payCenter/applybilling';
// 预开申请
import preApplyInvoice from '@/views/payCenter/preApplyInvoice';

import invoiceDetail from '@/views/payCenter/invoiceDetail';

// 风控开票记录
import invoiceRecord from '@/views/payCenter/invoiceRecord';
import invoiceRecordDtl from '@/views/payCenter/invoiceRecordDtl';

// 开票信息管理
// 电子回单
import electronicReceipt from '@/views/payCenter/electronicReceipt';
// 完税证明
import taxProveList from '@/views/payCenter/taxProveList';
// 导出完税证明记录
import payCertExportLogs from '@/views/payCenter/payCertExportLogs';
// 发票申请
import invoiceApply from '@/views/payCenter/invoiceApply';
// 三方通道管理
import tripartiteChannel from '@/views/payCenter/tripartiteChannel';
/**
 * 数据中心
 */
// 自由职业者结算统计
import ReceivableTransactionStatistics from '@/views/dataCenter/ReceivableTransactionStatistics';
// 商户结算统计
import BusinessStatistics from '@/views/dataCenter/BusinessStatistics';
// 批次明细交易信息查询
import batchmation from '@/views/dataCenter/batchmation';



/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
// import Permission from '@/views/system/Permission';

// 代理商
import agentIndex from '@/views/agent/index';
import agentBatchStatistics from '@/views/agent/agentStatistics';
import agentMerchantStatistics from '@/views/agent/agentMerchantStatistics';
import agentMerchantList from '@/views/agent/merchantList';
import agentRate from '@/views/agent/agentRate';

// 代理商
import saleIndex from '@/views/sales/index';
import salesBatchStatistics from '@/views/sales/salesBatchStatistics';
import salesMerchantStatistics from '@/views/sales/salesMerchantStatistics';
import saleMerchantList from '@/views/sales/merchantList';



// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
            {
                path: '/index/work',
                name: '首页',
                component: work,
                iconCls: 'el-icon-tickets',
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/task/taskList',
                name: '任务列表',
                component: taskList,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/task/registrationDtl',
                name: '报名详情',
                component: registrationDtl,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/task/employmentStatement',
                name: '用工结算单',
                component: employmentStatement,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/task/employmentStatementSubmit',
                name: '提交结算单',
                component: employmentStatementSubmit,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/task/employmentStatementDetail',
                name: '用工结算单详情',
                component: employmentStatementDetail,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/task/employmentStatementDesc',
                name: '用工结算明细',
                component: employmentStatementDesc,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/task/professionalList',
                name: '自由职业者列表',
                component: professionalList,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/task/exportList',
                name: '导出列表',
                component: exportList,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/task/contractMigrationLog',
                name: '导入列表',
                component: contractMigrationLog,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/task/contractMigrationLogDtl',
                name: '导入详情列表',
                component: contractMigrationLogDtl,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/task/registrationExportList',
                name: '报名详情-导出记录',
                component: registrationExportList,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/payCenter/payExportList',
                name: '开票记录-导出记录',
                component: payExportList,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/ruleCenter/complianceCenter',
                name: '任务信息维护',
                component: complianceCenter,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/manageCenter/contractManage',
                name: '合同管理',
                component: contractManage,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/payCenter/balanceManage',
                name: '余额管理',
                component: balanceManage,
                meta: {
                    requireAuth: true
                }
            },
            // 销售/代理商风控管理
            {
                path: '/payCenter/balance',
                name: '余额管理',
                component: balance,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/payCenter/rechargeRecord',
                name: '充值记录',
                component: rechargeRecord,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/payCenter/billingRecordList',
                name: '开票记录',
                component: billingRecordList,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/payCenter/invoiceDetail',
                name: '开票记录',
                component: invoiceDetail,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/payCenter/applybilling',
                name: '申请开票',
                component: applybilling,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/payCenter/preApplyInvoice',
                name: '预开申请',
                component: preApplyInvoice,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/payCenter/electronicReceipt',
                name: '电子回单',
                component: electronicReceipt,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/payCenter/taxProveList',
                name: '完税证明',
                component: taxProveList,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/payCenter/payCertExportLogs',
                name: '导出完税证明记录',
                component: payCertExportLogs,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/payCenter/invoiceApply',
                name: '发票申请',
                component: invoiceApply,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/payCenter/tripartiteChannel',
                name: '三方通道管理',
                component: tripartiteChannel,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/dataCenter/ReceivableTransactionStatistics',
                name: '自由职业者结算统计',
                component: ReceivableTransactionStatistics,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/dataCenter/BusinessStatistics',
                name: '商户结算统计',
                component: BusinessStatistics,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/dataCenter/batchmation',
                name: '批次明细交易信息查询',
                component: batchmation,
                meta: {
                    requireAuth: true
                }
            }, , {
                path: '/system/user',
                name: '用户管理',
                component: user,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Module',
                name: '菜单管理',
                component: Module,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Role',
                name: '角色管理',
                component: Role,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Dept',
                name: '公司管理',
                component: Dept,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Variable',
                name: '系统环境变量',
                component: Variable,
                meta: {
                    requireAuth: true
                }
            },
            // 风控查看数据
            {
                path: '/task/merchantList',
                name: '结算商户',
                component: merchantList,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/payCenter/invoiceRecord',
                name: '开票记录',
                component: invoiceRecord,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/payCenter/invoiceRecordDtl',
                name: '开票详情',
                component: invoiceRecordDtl,
                meta: {
                    requireAuth: true
                }
            },

            // 代理
            {
                path: '/agent/index',
                name: '首页',
                component: agentIndex,
                iconCls: 'el-icon-tickets',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/agent/agentStatistics',
                name: '批次统计',
                component: agentBatchStatistics,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/agent/agentMerchantStatistics',
                name: '商户统计',
                component: agentMerchantStatistics,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/agent/merchantList',
                name: '商户列表',
                component: agentMerchantList,
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/agent/agentRate',
                name: '档案中心',
                component: agentRate,
                meta: {
                    requireAuth: true
                }
            },

            // 销售
            {
                path: '/sales/index',
                name: '首页',
                component: saleIndex,
                iconCls: 'el-icon-tickets',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/sales/salesBatchStatistics',
                name: '批次统计',
                component: salesBatchStatistics,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/sales/salesMerchantStatistics',
                name: '商户统计',
                component: salesMerchantStatistics,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/sales/merchantList',
                name: '商户列表',
                component: saleMerchantList,
                meta: {
                    requireAuth: true
                }
            }
        ]
    }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js